<template>
  <div class="upload_wrap">
    <!-- 图片上传组件辅助-->
    <div v-if="fileUrl.name" class="file_box" @click.stop="handleNone">
      <p style="margin: 0;">{{ fileUrl.name }}</p>
      <i class="close_btn el-icon-error" @click.stop="closeFn" style="font-size: 20px; color: red"></i>
    </div>
    <i v-if="quillUpdate" class="el-icon-loading avatar-uploader-icon" style="font-size: 25px; color: #999"></i>
    <el-upload class="avatar-uploader" :action="uploadUrl+action" name="file" :headers="header" :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :disabled="quillUpdate">
      <el-button v-if="fileUrl.id" size="small" type="primary">重新上传</el-button>
      <el-button v-if="!fileUrl.id" size="small" type="primary">上传</el-button>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
			default(){
				return {
					id:'',
					name:'',
				}
			}
    },
    action: {
      type: String,
      default: "/upload/uploadToLocal",
    },
  },
  data() {
    return {
      fileUrl: this.value,
      quillUpdate: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      header: {},// token: sessionStorage.getItem("token")
    };
  },
  watch: {
    value: function (val) {
      this.fileUrl = val;
    },
    fileUrl: function (val) {
      this.$emit("file-event", val);
    },
  },
  methods: {
    closeFn() {
      this.fileUrl = {
				id:'',
				name:'',
			};
    },
    handleNone() {
      // this.fileUrl = '';
      // let link = document.createElement("a");
      // link.style.display = "none";
      // link.href = `${this.uploadUrl}/upload/download?id=${this.fileUrl.id}&openStyle=1`;
      // link.target = "_blank";
      // link.click();
			window.open(`${this.uploadUrl}/upload/download?id=${this.fileUrl.id}&openStyle=1`, '_blank');
    },
    beforeUpload(file) {
			let regexp = /.*\.(?:(?!(exe|dll|cmd|bat|vbs)).)+/
      this.quillUpdate = true;
      // const isDocument = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			const isDocument = regexp.test(file.name)
			const isLt300M = file.size / 1024 / 1024 <= 300;
      if (!isDocument) {
        this.$message.error('课程资料不能是exe，dll，cmd，bat，vbs等特殊格式文件！');
				this.quillUpdate = false;
      }
      if (!isLt300M) {
         this.$message.error('文件大小不能超过 300MB!');
				 this.quillUpdate = false;
      }
      // return isJPG && isLt300M;
      return isDocument && isLt300M;
    },
    uploadSuccess(res,file) {
      // this.fileUrl = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.$message.success("上传成功",res,file);
        this.fileUrl = {
					id:res.data[0],
					name:file.name,
				}
      } else {
        this.$message.error("上传失败");
      }
      this.quillUpdate = false;
    },
    uploadError() {
      this.quillUpdate = false;
      this.$message.error("上传失败");
    },
  },
};
</script> 

<style scoped>
.upload_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.file_box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  height: 30px;
  padding: 0 20px;
  cursor: pointer;
  /* max-width: calc(100% - 150px); */
	max-width: 70%;
}
.file_box p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* max-width: 80%; */
}
.loading_icon {
  position: absolute;
}
.close_btn {
  position: absolute;
  top: -8px;
  right: -8px;
}
.upload_wrap >>> .avatar-uploader .el-upload {
  border-radius: 0;
  border: none;
  cursor: pointer;
  overflow: inherit;
  width: auto;
  height: 32px;
  max-width: 100%;
}
</style>